var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "body",
    d: "M21 14.2V8.91002C21 8.02002 19.92 7.57002 19.29 8.20002L17 10.5V7.00002C17 6.45002 16.55 6.00002 16 6.00002H10.39L19.3 14.91C19.92 15.54 21 15.09 21 14.2ZM2.70998 2.56002C2.31998 2.95002 2.31998 3.58002 2.70998 3.97002L4.72998 6.00002H3.99998C3.44998 6.00002 2.99998 6.45002 2.99998 7.00002V17C2.99998 17.55 3.44998 18 3.99998 18H16C16.21 18 16.39 17.92 16.55 17.82L19.03 20.3C19.42 20.69 20.05 20.69 20.44 20.3C20.83 19.91 20.83 19.28 20.44 18.89L4.11998 2.56002C3.72998 2.17002 3.09998 2.17002 2.70998 2.56002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "red-line",
    d: "M2.70998 3.97002C2.31998 3.58002 2.31998 2.95002 2.70998 2.56002C3.09998 2.17002 3.72998 2.17002 4.11998 2.56002L20.44 18.89C20.83 19.28 20.83 19.91 20.44 20.3C20.05 20.69 19.42 20.69 19.03 20.3L2.70998 3.97002Z",
    fill: "#DD5068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.d2c9169265df1d3222ac2bb0435b8a8d.svg";
export { ForwardRef as ReactComponent };